"use client";

import { useRouter } from "next/navigation";
import {
  GALLERY_SORT_OPTIONS,
  normalizeGallerySort,
  withGallerySortParam,
} from "@/lib/gallerySort";
import { withGallerySearchParam } from "@/lib/gallerySearch";
import type { GallerySort } from "@/types/gallery";

export default function GallerySortSelect({
  action,
  search,
  sort,
}: {
  action: string;
  search: string;
  sort: GallerySort;
}) {
  const router = useRouter();
  return (
    <form
      action={action}
      method="get"
      className="hidden items-center gap-2 lg:flex"
    >
      {search ? <input type="hidden" name="q" value={search} /> : null}
      <label htmlFor="gallery-sort" className="sr-only">
        Sort dresses
      </label>
      <select
        id="gallery-sort"
        name="sort"
        value={sort}
        onChange={event =>
          router.push(
            withGallerySearchParam(
              withGallerySortParam(
                action,
                normalizeGallerySort(event.target.value)
              ),
              search
            )
          )
        }
        className="h-11 rounded-lg border border-border bg-background px-3 text-sm text-foreground focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring"
      >
        {GALLERY_SORT_OPTIONS.map(option => (
          <option key={option.value} value={option.value}>
            {option.label}
          </option>
        ))}
      </select>
      <noscript>
        <button type="submit" className="min-h-11 px-3 text-sm">
          Apply sort
        </button>
      </noscript>
    </form>
  );
}
